import
  React
from 'react';

import
  PropTypes
from 'prop-types';

import {
  HContainerVH,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  TextRow
} from 'components';

import {
  CustomColors,
  Icons
} from '../../../../constants';

export const VoucherGiftCard = (props) => {

  return (

    <VContainer
      width={'100%'}
      height={'150px'}
      maxWidth={'296px'}
      margin={'16px 16px 32px'}
      padding={'0 16px 16px'}
      boxSizing={'border-box'}
      borderRadius={'10px'}
      background={`url(${Icons.VoucherCardPattern}) center 100% no-repeat, ${CustomColors.GradientRed}`}
      position={'relative'}
      justifyContent={'flex-end'}>

      <TextRow
        margin={'0'}
        alignItems={'flex-end'}
        leftText={props.vendor}
        rightText={props.price}
        leftFontColor={CustomColors.White}
        leftFontWeight={'bold'}
        leftFontSize={'18px'}
        leftLineHeight={'25px'}
        rightFontColor={CustomColors.White}
        rightFontWeight={'bold'}
        rightFontSize={'30px'}
        rightLineHeight={'30px'}/>

      <TextRow
        margin={'0'}
        alignItems={'flex-end'}
        leftText={`Expires ${props.expiryDate}`}
        rightText={props.type}
        leftFontColor={CustomColors.White}
        leftFontSize={'13px'}
        leftLineHeight={'20px'}
        rightFontColor={CustomColors.White}
        rightFontWeight={'bold'}
        rightFontSize={'16px'}
        rightLineHeight={'20px'}/>

      { !!props.badgeText &&

        <HContainerVH
          top={'0'}
          left={'0'}
          position={'absolute'}
          width={'88px'}
          height={'18px'}
          borderRadius={'8px 0px'}
          backgroundColor={CustomColors.White}>

          <Text
            color={CustomColors.Red5}
            fontWeight={'bold'}
            fontSize={'14px'}
            lineHeight={'14px'}>

            {props.badgeText}
          </Text>
        </HContainerVH>
      }

    </VContainer>
  );
};

VoucherGiftCard.propTypes = {
  badgeText: PropTypes.string,
  vendor: PropTypes.string.isRequired,
  price: PropTypes.string.isRequired,
  expiryDate: PropTypes.string.isRequired,
  type: PropTypes.string
};

VoucherGiftCard.defaultProps = {
  badgeText: '',
  vendor: '',
  price: '',
  expiryDate: '',
  type: 'Voucher'
};